import { render, staticRenderFns } from "./SecondBtn.vue?vue&type=template&id=33529941&"
import script from "./SecondBtn.vue?vue&type=script&lang=js&"
export * from "./SecondBtn.vue?vue&type=script&lang=js&"
import style0 from "./SecondBtn.vue?vue&type=style&index=0&id=33529941&prod&lang=sass&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports